import { Component, OnInit } from '@angular/core';
import { UploadServiceService } from '../service/upload-service.service';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { take } from 'rxjs/operators';

@Component({
    selector: 'app-view-question',
    templateUrl: './view-question.component.html',
    styleUrls: ['./view-question.component.css'],
    standalone: false
})
export class ViewQuestionComponent implements OnInit {

  constructor(private uploadService:UploadServiceService, private router:Router,private dialogRef:MatDialogRef<ViewQuestionComponent>) { }

  typeId="math"
  questionId="1347670e-9f43-4cef-ba23-e12f68fd5d12"
  questionObj:any= {};

  ngOnInit(): void {
    this.uploadService.$questionId.pipe(take(1)).subscribe((data) => {
      const questionObj = JSON.parse(data);
      this.uploadService.getQuestionById(questionObj.questionId).pipe(take(1)).subscribe((data) => {
        this.questionObj = data["resp"];
      });
    });
    // this.uploadService.getQuestionById(this.questionId).subscribe((data)=>{
    //   if(data){
    //     // set question
    //     this.questionObj = data["resp"]
    //   }
    // })
  }

  getQuestionMediaLength(){
    if('questionMedia' in this.questionObj && this.questionObj['questionMedia'].length>0){
      return true;
    }
    return false;
  }
  checkIfOptionsPresent(){
    if('options' in this.questionObj && this.questionObj['options'].length>0){
      return true;
    }
    return false;
  }
  checkIfInOption(option:object,objKey:string){
    if(objKey in option){
      return true;
    }
    return false;
  }

  editQuestionRoute(questionId:string){
    this.dialogRef.close(true);
    this.router.navigate(['/create-question'],{ queryParams: { "questionId": questionId}})
  }

  deleteQuestion(questionId:string,typeId:string){
    if(!confirm("Are you sure you want to delete this question?")){
      return;
    }
    this.uploadService.deleteQuestion(questionId,typeId).subscribe((data)=>{
      console.log(data);
      if("resp" in data && data["resp"]["$metadata"]["httpStatusCode"]==200){
        alert("Question deleted successfully");
        this.dialogRef.close(true);
        this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
          this.router.navigate(['/list-questions']);
        });
      }
    })
  }

}
